import { render, staticRenderFns } from "./TipTapMenuItem.vue?vue&type=template&id=549d56a8&scoped=true&"
import script from "./TipTapMenuItem.vue?vue&type=script&lang=js&"
export * from "./TipTapMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TipTapMenuItem.vue?vue&type=style&index=0&id=549d56a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d56a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
